Auth = require 'db/auth'
SimpleTest = require('common/lib/experiments/simple-test').default
Token = require('common/lib/util/token').default
getAudienceDefinitions = require('common/lib/experiments/audience-definitions').default

testCache = {}
getMember = -> if me = Auth.me() then me.toJSON() else null
audienceDefinitions = getAudienceDefinitions(getMember)
simpleTest = new SimpleTest(audienceDefinitions)

module.exports = (testName, identifier) ->
  identifier = identifier or Token.getMyId() or 'notLoggedIn'
  key = [testName, identifier].filter((a) -> a).join(':')
  testCache[key] ?= simpleTest.getParams(testName, identifier)



// WEBPACK FOOTER //
// ./app/scripts/lib/experiments/simple-test.coffee